// src/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "./apiConfig";

function Login({ onLogin, onToggle }) {
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
  const res = await fetch(`${API_BASE_URL}/login-api/login.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ correo, password }),
      });

      const data = await res.json();

      if (data.success) {
        const userData = {
          correo: data.correo,
          role: data.role,
          user_id: data.user_id ?? null,
        };

  localStorage.setItem("user", JSON.stringify(userData));
  localStorage.setItem("role", data.role);
        if (onLogin) onLogin(userData);

        if (data.role === "admin") navigate("/proyecto/panel");
        else if (data.role === "analista") navigate("/proyecto/cubo");
        else navigate("/proyecto/mapeo");
      } else {
        setError(data.message || "Error en las credenciales");
      }
    } catch (err) {
      console.error(err);
      setError("Error en la conexión con el servidor");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-800 via-red-900 to-gray-900 p-6">
      <div className="w-full max-w-md bg-white/10 backdrop-blur-lg rounded-2xl shadow-2xl border border-red-400/30 p-8 transform transition duration-500 hover:scale-[1.02] hover:shadow-red-500/40">
        
        {/* 🖼️ Logo en la parte superior */}
        <div className="flex flex-col items-center mb-6">
          <img
            src="/images/fe5.png"
            alt="Logo Element5"
            className="w-20 h-20 object-contain drop-shadow-lg"
          />
          <h2 className="text-3xl font-extrabold text-center text-white mt-4 tracking-wide">
             <span className="text-red-400">Element5</span>
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-semibold text-gray-100 mb-2">
              Correo electrónico
            </label>
            <input
              type="email"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              className="w-full px-4 py-3 bg-white/20 text-white border border-red-400/40 rounded-xl placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
              placeholder="usuario@element5.mx"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-100 mb-2">
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 bg-white/20 text-white border border-red-400/40 rounded-xl placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
              placeholder="••••••••"
              required
            />
          </div>

          {error && (
            <div className="text-red-300 text-center font-medium animate-pulse">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="w-full py-3 rounded-xl bg-gradient-to-r from-red-600 to-red-400 text-white font-semibold text-lg shadow-md hover:from-red-500 hover:to-red-300 transition-all duration-300 hover:shadow-red-400/50"
          >
            Iniciar sesión
          </button>

          <div className="text-center mt-4">
            <button
              type="button"
              onClick={() => onToggle && onToggle()}
              className="text-sm text-red-300 hover:text-red-200 hover:underline transition-all"
            >
              ¿No tienes cuenta? Regístrate aquí
            </button>
          </div>
        </form>

        <div className="mt-6 text-center text-gray-300 text-xs">
          © {new Date().getFullYear()} Element5 | Sistema Empresarial
        </div>
      </div>
    </div>
  );
}

export default Login;
